import { render, staticRenderFns } from "./RichMenu.vue?vue&type=template&id=19a5e63b"
import script from "./RichMenu.vue?vue&type=script&lang=js"
export * from "./RichMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19a5e63b')) {
      api.createRecord('19a5e63b', component.options)
    } else {
      api.reload('19a5e63b', component.options)
    }
    module.hot.accept("./RichMenu.vue?vue&type=template&id=19a5e63b", function () {
      api.rerender('19a5e63b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/RichMenu/RichMenu.vue"
export default component.exports